import { render, staticRenderFns } from "./messageTaskModal.vue?vue&type=template&id=1490c655&scoped=true&"
import script from "./messageTaskModal.vue?vue&type=script&lang=js&"
export * from "./messageTaskModal.vue?vue&type=script&lang=js&"
import style0 from "./messageTaskModal.vue?vue&type=style&index=0&id=1490c655&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1490c655",
  null
  
)

export default component.exports